<script>
  import Container from '@/Elements/Containers/FullCentred.svelte';
  import Meta from '@/Elements/Signals/Dark/Meta/XSmall.svelte';
  import Title from '@/Elements/Signals/Dark/Title.svelte';
  import Lead from '@/Elements/Signals/Dark/Text/Base.svelte';
  import Text from '@/Elements/Signals/Dark/Text/Base.svelte';
  import Heading from '@/Elements/Signals/Dark/Text/Base.svelte';
  import Point from '@/Elements/Signals/Dark/Text/Small.svelte';
  import Header from '@/Elements/Signals/Dark/Headers/Large.svelte';

  export let summary;

  let meta = summary.meta;
  let title = summary.title;
  let content = summary.content;
  let aux = summary.aux;
  let list = summary.list;
</script>

<style></style>

<section id="summary" class="py-12">
  <Container>
    <div class="flex flex-col lg:flex-row lg:items-center">
      <div class="px-var py-6 space-y-12 lg:w-3/5">
        <div class="space-y-3">
          <div class="space-y-1">
            <Meta>{meta}</Meta>
            <Title>{title}</Title>
          </div>
          <Lead>{content.lead}</Lead>
        </div>
        <div class="space-y-12">
          <div class="space-y-9">
            {#each content.list as item}
              <div class="flex flex-row">
                <div class="space-y-2">
                  <Header>{item.title}</Header>
                  <Text>{item.text}</Text>
                </div>
              </div>
            {/each}
          </div>
        </div>
      </div>
      <div class="px-var lg:ml-auto">
        <div class="space-y-6 bg-gray-100 px-6 py-8 md:py-16 md:px-12 rounded-sm shadow-md">
          <div class="">
            <Header>{aux.title}</Header>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 ">
            {#each list as item}
              <div class="space-y-8 ">
                {#each item as {header, info}}
                  <div class="">
                    <Heading><span class="font-semibold">{header}</span></Heading>
                    <div class="space-y-1 ">
                      {#each info as text}
                        <Point>{text}</Point>
                      {/each}
                    </div>
                  </div>
                {/each}
              </div>
            {/each}
          </div>
        </div>
      </div>
    </div>
  </Container>
</section>